import type { RouteObject } from 'react-router';
import type { ComponentType } from 'react';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type Page = { default: ComponentType };
const page = (load: () => Promise<Page>): RouteObject['lazy'] => async () => ({ Component: (await load()).default });
export const invoiceRoutes: RouteObject[] = [
  { path: '/invoices/library', lazy: page(() => import('./pages/InvoiceLibraryPage.js')) },
  { path: '/invoices/recurring', lazy: page(() => import('./pages/InvoiceRecurringPage.js')) },
  { path: '/invoices/import', lazy: page(() => import('./pages/InvoiceImportPage.js')) },
  { path: '/invoices', lazy: page(() => import('./pages/InvoiceListPage.js')) },
  { path: '/invoices/new', lazy: page(() => import('./pages/InvoiceEditorPage.js')) },
  { path: '/invoices/documents/:id', lazy: page(() => import('./pages/InvoiceDetailPage.js')) },
  { path: '/invoices/documents/:id/edit', lazy: page(() => import('./pages/InvoiceEditorPage.js')) },
  { path: '/invoices/payments', lazy: page(() => import('./pages/InvoicePaymentsPage.js')) },
  { path: '/invoices/products', lazy: page(() => import('./pages/InvoiceProductsPage.js')) },
  { path: '/invoices/payments/:id/voucher', lazy: page(() => import('./pages/InvoicePaymentVoucherPage.js')) },
  { path: '/invoices/statements', lazy: page(() => import('./pages/InvoiceStatementsPage.js')) },
  { path: '/invoices/statements/:id', lazy: page(() => import('./pages/InvoiceStatementDetailPage.js')) },
  { path: '/invoices/ledger', lazy: page(() => import('./pages/InvoiceLedgerPage.js')) },
  { path: '/invoices/reports/receivables', lazy: page(() => import('./pages/InvoiceAgingPage.js')) },
  { path: '/invoices/partners/:customerId/ledger', lazy: page(() => import('./pages/InvoiceLedgerPage.js')) },
  { path: '/invoices/settings', lazy: page(() => import('./pages/InvoiceSettingsPage.js')) },
  { path: '/invoices/settings/numbering', lazy: page(() => import('./pages/InvoiceNumberingPage.js')) },
  { path: '/invoices/settings/templates', lazy: page(() => import('./pages/InvoiceTemplatesPage.js')) },
  { path: '/invoices/partners', lazy: page(() => import('./pages/InvoicePartnersPage.js')) },
  { path: '/invoices/projects', lazy: page(() => import('./pages/InvoiceProjectsPage.js')) },
  { path: '/invoices/projects/:projectId', lazy: page(() => import('./pages/InvoiceProjectDetailPage.js')) },
  // ---- 2026-10-03（gap-invoice-b）: 赤伝・開始残高・送付の全体・締め処理 ----
  { path: '/invoices/credit-notes/:id', lazy: page(() => import('./pages/InvoiceCreditNotePage.js')) },
  { path: '/invoices/opening-balances', lazy: page(() => import('./pages/InvoiceOpeningBalancesPage.js')) },
  { path: '/invoices/deliveries', lazy: page(() => import('./pages/InvoiceDeliveriesPage.js')) },
  { path: '/invoices/closings', lazy: page(() => import('./pages/InvoiceClosingsPage.js')) },
];

export const invoicePublicRoutes: RouteObject[] = [
  { path: '/invoice-share', lazy: page(() => import('./pages/InvoicePublicSharePage.js')) },
];
